<div style="display: flex; flex-direction: column; align-items: center">
  <h2 class="mat-headline-4">Adding items to cart</h2>
  <mat-spinner></mat-spinner>
</div>
